/* eslint react-hooks/exhaustive-deps: off */

import { useEffect } from 'react'

const useMountEffect = (effect) => {
  useEffect(effect, [])
}

export default useMountEffect
